import { Observable } from 'rxjs';

import { TokenResponseData } from '@mirage-projects/cw-models';

/**
 * Abstract service definition to manage the Collage Cloud entry points.
 */
export abstract class CollageCloudService {
    /**
     * Gets the thumbnail url redirection
     * @param url Url where to get th redirection
     */
    abstract getRedirectURL(url: string): Observable<string>;

    abstract login(username: string, password: string): Observable<TokenResponseData>;
}
